import { render, staticRenderFns } from "./transferInfo.vue?vue&type=template&id=85e13e9c&"
import script from "./transferInfo.vue?vue&type=script&lang=js&"
export * from "./transferInfo.vue?vue&type=script&lang=js&"
import style0 from "./transferInfo.vue?vue&type=style&index=0&id=85e13e9c&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports